import React from 'react';
import { Roles } from 'configs/roles';
import { Actions } from 'configs/actions';
import { MainRouteKeys } from 'routes/enums';
// import { TFunction } from 'i18next';
import { MainRoutesConfig } from 'routes/main/config';
import { checkValidActionRoleAdmin, checkValidRole } from 'utils/helpers';
import type { UserAccess } from 'utils/helpers';

export const menusRenderer = (access?: UserAccess) => {
  const menuItems = [
    {
      ...MainRoutesConfig[MainRouteKeys.Personal],
      childs: [
        MainRoutesConfig[MainRouteKeys.PersonalInfo],
        MainRoutesConfig[MainRouteKeys.PersonalFinancialLimits],
        MainRoutesConfig[MainRouteKeys.PersonalTwoFaSecurity],
        MainRoutesConfig[MainRouteKeys.PersonalChangePassword],
        // MainRoutesConfig[MainRouteKeys.PersonalReward],
        MainRoutesConfig[MainRouteKeys.PersonalLogout],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.Balance],
      childs: [
        MainRoutesConfig[MainRouteKeys.BalanceManage],
        MainRoutesConfig[MainRouteKeys.TopUp],
        MainRoutesConfig[MainRouteKeys.Transfers],
        MainRoutesConfig[MainRouteKeys.TransfersToBankBIDV],
        // MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceCreate],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.RequestWithdraw],
      childs: [
        MainRoutesConfig[MainRouteKeys.BankManagement],
        MainRoutesConfig[MainRouteKeys.CreateRequestWithdraw],
        MainRoutesConfig[MainRouteKeys.RequestWithdrawOwn],
        MainRoutesConfig[MainRouteKeys.CheckRequestWithdrawList],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidence],
      childs: [
        MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceCreate],
        MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceOwn],
        MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceAll],
      ],
    },
    // {
    //   ...MainRoutesConfig[MainRouteKeys.PayBill],
    //   childs: [MainRoutesConfig[MainRouteKeys.PayBillElectric]],
    // },
    {
      ...MainRoutesConfig[MainRouteKeys.Transactions],
      childs: [
        // MainRoutesConfig[MainRouteKeys.TransactionBills],
        MainRoutesConfig[MainRouteKeys.PointTransactions],
        // MainRoutesConfig[MainRouteKeys.PointRewardTransactions],
      ],
    },
    // MainRoutesConfig[MainRouteKeys.Orders],
    // {
    //   ...MainRoutesConfig[MainRouteKeys.Dashboard],
    //   childs: [
    //     MainRoutesConfig[MainRouteKeys.DashboardReportByPC],
    //     MainRoutesConfig[MainRouteKeys.DashboardReportByAgency],
    //   ],
    // },
    {
      ...MainRoutesConfig[MainRouteKeys.CompanyDepartment],
      childs: [MainRoutesConfig[MainRouteKeys.Company]],
    },
    MainRoutesConfig[MainRouteKeys.Users],
    {
      ...MainRoutesConfig[MainRouteKeys.Refferal],
      childs: [
        MainRoutesConfig[MainRouteKeys.RefferalDetail],
        MainRoutesConfig[MainRouteKeys.RefferalDetailHistory],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.EnergyDepartment],
      childs: [
        MainRoutesConfig[MainRouteKeys.TransactionEnergy],
        MainRoutesConfig[MainRouteKeys.BranchEnergy],
        MainRoutesConfig[MainRouteKeys.SupplierEnergy],
        MainRoutesConfig[MainRouteKeys.GasStation],
      ],
    },
    // MainRoutesConfig[MainRouteKeys.ElectricBill],
    // MainRoutesConfig[MainRouteKeys.Customers],
    {
      ...MainRoutesConfig[MainRouteKeys.TPBank],
      childs: [
        MainRoutesConfig[MainRouteKeys.AccountBank],
        MainRoutesConfig[MainRouteKeys.TransactionsBank],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.BidvVirtualAccount],
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
      screenAction: [
        Actions.ManageBIDVVAS_InqueryTransaction,
        Actions.ManageBIDVVAS_SyncTransaction,
        Actions.ManageBIDVTransaction_Inquiry,
        Actions.ManageBIDVTransaction_Sync,
      ],
      childs: [
        MainRoutesConfig[MainRouteKeys.BidvVirtualAccountInquiry],
        MainRoutesConfig[MainRouteKeys.BidvTransHistory],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.BidvBankTransfer],
      childs: [
        MainRoutesConfig[MainRouteKeys.BidvBankTransferReconciliation],
        MainRoutesConfig[MainRouteKeys.BidvBankTransferWhitelist],
        MainRoutesConfig[MainRouteKeys.BidvTransferDestWhitelist],
      ],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.AuditLogsAdmin],
      childs: [],
    },
    {
      ...MainRoutesConfig[MainRouteKeys.Settings],
      childs: [
        MainRoutesConfig[MainRouteKeys.AppVersionConfig],
        MainRoutesConfig[MainRouteKeys.UnlockSmsRateLimit],
        MainRoutesConfig[MainRouteKeys.BalanceOperationControls],
      ],
    },
    // MainRoutes[MainRouteKeys.Transactions],
    // MainRoutes[MainRouteKeys.Transfer],
  ];

  return menuItems
    .filter((item) => {
      return (
        checkValidRole(item.roles, access?.roles) &&
        checkValidActionRoleAdmin(item.screenAction, access)
      );
    })
    .map((item) => {
      return {
        title: item.name,
        path: item.path,
        icon: item?.icon || <></>,
        childs: (item?.childs || [])
          .filter((child: any) => {
            return (
              checkValidRole(child.roles, access?.roles) &&
              checkValidActionRoleAdmin(child.screenAction, access)
            );
          })
          .map((child) => {
            return {
              title: child.name,
              path: child.path,
              icon: child?.icon || <></>,
            };
          }),
      };
    });
};
